
import React, { useState, useEffect } from 'react';
import './index.scss';
import { connect } from 'react-redux'

import { closeAssignSubscription } from '../../../../../action/sub-showAssigne-action';
import { closeManageSubscription } from '../../../../../action/manage-subscription';
import AssignSuccessScreen from './AssignSuccessScreen';
import { assignSubscription } from '../../../../../action/group-subscription-api';
import DefaultIcon from '../../../../../../asset/User-Profile_Solid_E5E5E5_SVG.png'


const FriendsList = (props) => {
  const [users, setUser] = useState(props.friendsList)

  // let val = props.subscriptionAssigned.assignedSubscriptions

  let assignSubscription = (user) => {
    props.LoadAssignSpinner()
    let payload = { assignUserId: user.id, userSubId: props.subscriptionAssigned.userSubscriptionId }

    props.assignSubscription(payload)
      .then((res) => {
        props.assignSuccess()
        props.assignedUserConfirm(user)
        props.StopAssignSpinner()
      })
      .catch((err) => {
        props.StopAssignSpinner()
      })
  }

  useEffect(() => {
    setUser(props.friendsList)
    if (props.friendsList.length > 1) {
      // setSpinner(false)
    } else {
      setTimeout(() => {
        // setSpinner(false)
      }, 3000);
    }
  }, [props.friendsList])

  let handlesendInvite = () => {
    props.handlesendInvite()
  }


  return (
    <div className="user-assign-container">
      <div className="user-list">
        {users?.length >= 1 && !props.spinner ?
          users.map((user, index) => {
            // Check if user is already assigned a subscription
            const isAlreadyAssigned = props.subscriptionAssigned.assignedSubscriptions.some(
              (assignedUser) => assignedUser.userId === user.id
            );

            return (
              <div key={index} className="user-row">
                {/* <img src={user.thumbnailUrl ? user.thumbnailUrl : DefaultIcon} alt="avatar" className="avatar" /> */}

                <img
                  // src={user.thumbnailUrl ? user.thumbnailUrl : DefaultIcon}
                  src={user.thumbnailUrl || DefaultIcon}
                  className="avatar"
                  alt="avatar"
                  onError={(e) => {
                    e.currentTarget.src = DefaultIcon;
                    e.currentTarget.onerror = null; // avoid infinite loop
                  }}
                />

                <div className="user-info">
                  <div className="user-info-name">{user.fullName}</div>
                  <div className="user-info-email">{user.email}</div>
                </div>

                {isAlreadyAssigned || user.pro ? (
                  <button className="assign-button assigned"
                    style={{
                      backgroundColor: '#959595',
                      cursor: 'no-drop',
                      border: 'none'
                    }}
                    disabled>
                    Pro User
                  </button>
                ) : (
                  <button
                    className="assign-button"
                    // disabled={!user.pro}
                    style={{
                      // backgroundColor: user.pro ? '#959595' : '',
                      // cursor: user.pro ? 'no-drop' : '',
                      // border: user.pro ? 'none' : ''
                    }}
                    onClick={() => assignSubscription(user)}
                  >
                    Assign
                  </button>
                )}


                {/* <button className="assign-button" disabled={!user.pro} style={{ backgroundColor: user.pro ? '#959595' : '', cursor: user.pro ? 'no-drop' : '' }} onClick={() => assignSubscription(user)}>{'Assign'}</button> */}
              </div>
            )
          })
          : props.spinner ?
            <div className="friends-loader" style={{ top: '50%', background: '#589500', left: '45%' }}></div> :
            <p style={{ textAlign: 'center' }}>No results found</p>
        }

        {/* {props.spinner ?
          <div class="friends-loader" style={{ top: '50%', background: '#589500', left: '40%' }}></div> :
          <p style={{}}>No results found</p>
        } */}
      </div>

      {
        users?.length >= 1 &&
        <div className='prev-next-container'>
          <button className='prev-next-class'
            disabled={props.pageNumber <= 0 || props.spinner}
            style={{ background: props.pageNumber <= 0 ? '#959595' : props.spinner ? '#959595' : '', cursor: props.pageNumber <= 0 ? 'no-drop' : props.spinner ? 'no-drop' : '' }}
            onClick={() => { props.goBack() }}>
            Prev
          </button>

          <button className='prev-next-class'
            disabled={props.friendsList.length % 20 != 0 || props.spinner}
            style={{ background: props.friendsList.length % 20 == 0 ? props.spinner ? '#959595' : '' : '#959595', cursor: props.friendsList.length % 20 == 0 ? props.spinner ? 'no-drop' : '' : 'no-drop' }}
            onClick={() => { props.goNext() }}>
            Next
          </button>
        </div>
      }

      <div className="footer-invite">
        <p className="footer-text">Can’t find who you're looking for?</p>
        <button className="invite-button" onClick={() => { handlesendInvite() }}>SEND INVITE</button>
      </div>
    </div >
  );
};


const mapStateToProps = state => ({
  manageSubscription: state.manageSubscription,
  assignSubscriptionTab: state.assignSubscriptionTab,
  userSubscription: state.userSubscription,
  subscriptionAssigned: state.subscriptionAssigned,

})

const mapDispatchToProps = dispatch => ({
  closeManageSubscription: () => dispatch(closeManageSubscription()),
  closeAssignSubscription: () => dispatch(closeAssignSubscription()),
  assignSubscription: (payload) => dispatch(assignSubscription(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(FriendsList)


